export default "__VITE_ASSET__CRZK$KQe__"